"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATIONS_MIGRATION = void 0;
const COPY_1 = require("../messages/COPY.js");
exports.ORGANIZATIONS_MIGRATION = { MESSAGE: COPY_1.MESSAGES_COPY.PLEASE_SELECT_DIFFERENT_ORGANIZATION };
//# sourceMappingURL=ORGANIZATIONS_MIGRATION.js.map